import { connect } from 'react-redux';

import { getLanguage } from 'modules/language/selectors/language';

import RemoteMediaDisabled from './RemoteMediaDisabled';

const mapStateToProps = (state) => ({
  switchedLayout: state.conference.consultationInfo.switchedLayout,
  language: getLanguage(),
});

export default connect(
  mapStateToProps,
)(RemoteMediaDisabled);
